import React from 'react';
import PropTypes from 'prop-types';

import { cloudinaryUrl } from 'utils';
import SEO from 'common/seo';

const ContributePageSEO = ({ title, name, image }) => {
    const imageUrl = cloudinaryUrl(image, { transformation: 'facebook', secure: false });
    const secureImageUrl = cloudinaryUrl(image, { transformation: 'facebook', secure: true });

    return (
        <SEO>
            <title>{title}</title>
            <meta property="og:title" content={name} />
            <meta property="og:description" content="Campaign description" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={name} />
            <meta name="twitter:description" content="Campaign description" />

            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:secure_url" content={secureImageUrl} />
            <meta name="twitter:image" content={secureImageUrl} />
        </SEO>
    );
};

ContributePageSEO.propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
};

ContributePageSEO.defaultProps = {
    image: 'facebook-default.png',
};

export default ContributePageSEO;
